import { Button } from "../redesign/components/Button";
import { NewsFeedItemCommentsCount } from "./CommentsCount";

interface NewsFeedItemCommentsButtonProps {
  count: number;
  onClick?: () => void;
}

export function NewsFeedItemCommentsButton(props: NewsFeedItemCommentsButtonProps) {
  const { count, onClick = () => undefined } = props;

  return (
    <Button variant="outlined" onClick={onClick}>
      <NewsFeedItemCommentsCount includeText showIcon count={count} />
    </Button>
  );
}
